import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <motion.div
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 0.8,
        ease: [0.25, 1, 0.5, 1],
        delay: 0.2,
      }}
      className="fixed top-0 left-0 w-full z-50"
    >
      <div
        className={`mx-3 mt-3 px-4 py-3 flex justify-between items-center rounded-2xl transition-all duration-300 ${
          scrolled
            ? "bg-white/80 backdrop-blur-md shadow-md border border-white/40"
            : "bg-white/30 backdrop-blur-sm border border-white/20"
        }`}
      >
        {/* LEFT SIDE */}
        <div className="relative flex items-center">
          <a href="/" className="block relative">
            <img
              src="/logo.png"
              alt="A2Z Consultancy"
              className="absolute -top-2 md:-top-3 h-18 md:h-22 w-auto object-contain"
            />
            <div className="h-10 w-[120px]" />
          </a>
        </div>

        {/* RIGHT SIDE */}
        <div className="flex items-center gap-2 md:gap-3">
          <a href="/hire">
            <button className="relative px-4 md:px-5 py-2.5 text-sm md:text-[15px] font-semibold text-white rounded-xl bg-gradient-to-r from-violet-600 to-purple-500 shadow-[0_6px_18px_rgba(139,92,246,0.35)] hover:shadow-[0_10px_28px_rgba(139,92,246,0.45)] hover:-translate-y-[1px] active:scale-[0.98] transition-all duration-200">
              Hire Help
            </button>
          </a>

          <a href="/jobs">
            <button className="relative px-4 md:px-5 py-2.5 text-sm md:text-[15px] font-semibold text-gray-800 rounded-xl border border-gray-200 bg-white/80 backdrop-blur shadow-[0_4px_12px_rgba(0,0,0,0.08)] hover:shadow-[0_8px_20px_rgba(0,0,0,0.12)] hover:-translate-y-[1px] active:scale-[0.98] transition-all duration-200">
              Find Job
            </button>
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default Navbar;